/** 
 * 选择器 
 * @props dataList {Array} - 数据列表，二级联动或单列，有需要三级联动的我再改动一下吧
 * ex:  [{
        childOrg: [{
                id: 23,
                name: "测试支部二部",
                parentId: 11
            },
            {
                id: 51,
                name: "巴托俱乐部",
                parentId: 11
            }
        ],
        id: 11,
        name: "孤鸿寡鹄122",
        parentId: 0
        }]
 * @emit getSelIndex {Function}- 传递当前选中数组下标数组
 * ex: getSelIndex
 *     [0, 0]
 */

import nfPicker from "./nfPicker.vue"
export default nfPicker
